import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Editform(state = initialState, action) {
  switch (action.type) {
    case userConstants.EDITFORMDETAILS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.EDITFORMDETAILS_SUCCESS:
      const {res} = action
      return {
        res,
        isLoading : false
      };
    case userConstants.EDITFORMDETAILS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}